"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const RateTypeEnum_1 = require("../models/rates/RateTypeEnum");
const TransactionType_1 = require("../models/rates/TransactionType");
const RateDetailValidator_1 = __importDefault(require("./RateDetailValidator"));
const baseRate_schema_1 = __importDefault(require("./schemas/baseRate.schema"));
class PerTransactionRateValidator {
    constructor(rateDetailValidator) {
        this._rateDetailValidator =
            rateDetailValidator ?? new RateDetailValidator_1.default();
    }
    _rateDetailValidator;
    _rateDetailSchema = joi_1.default.object({
        conditions: joi_1.default.array().required(),
        groupingAndMins: joi_1.default.object().required(),
    });
    _rateSchema = joi_1.default.object({
        ...baseRate_schema_1.default,
        rateType: joi_1.default.string()
            .valid(RateTypeEnum_1.RateTypeEnum.PerTransactionRate)
            .required(),
        detail: this._rateDetailSchema.required(),
        customerId: joi_1.default.string().optional(),
        isUomCountRate: joi_1.default.boolean().optional(),
        glAccount: joi_1.default.when('customerId', {
            is: joi_1.default.exist(),
            then: joi_1.default.string().allow('').optional(),
            otherwise: joi_1.default.forbidden(),
        }),
        assignedCustomers: joi_1.default.number().integer().min(0).optional(),
        assignedRateSheets: joi_1.default.number().integer().min(0).optional(),
    });
    validate(rate) {
        const issues = [];
        const { error } = this._rateSchema.validate(rate, {
            abortEarly: false,
            convert: false,
        });
        if (error) {
            issues.push(...this.handleValidationError(error));
        }
        try {
            const rateDetail = rate.detail;
            const isUomCountRate = Boolean(rate.isUomCountRate);
            const transactionType = rate.transactionType;
            switch (transactionType) {
                case TransactionType_1.TransactionType.Adjustments: {
                    this._rateDetailValidator.adjustments.validate(rateDetail, isUomCountRate);
                    break;
                }
                case TransactionType_1.TransactionType.Receiving: {
                    this._rateDetailValidator.receiving.validate(rateDetail, isUomCountRate);
                    break;
                }
                case TransactionType_1.TransactionType.Returns: {
                    this._rateDetailValidator.returns.validate(rateDetail, isUomCountRate);
                    break;
                }
                case TransactionType_1.TransactionType.Assemblies: {
                    this._rateDetailValidator.assemblies.validate(rateDetail, isUomCountRate);
                    break;
                }
                case TransactionType_1.TransactionType.Shipping: {
                    this._rateDetailValidator.shipping.validate(rateDetail, isUomCountRate);
                    break;
                }
            }
        }
        catch (error) {
            if (error instanceof errors_1.ValidationError) {
                issues.push(...error.validationIssues);
            }
            else {
                issues.push(new errors_1.Errors.ValidationIssue('IRate', errors_1.Errors.ValidationErrorCode.invalidValue, 'detail', rate.detail));
            }
        }
        if (issues.length > 0) {
            const validationError = new errors_1.Errors.ValidationError();
            validationError.validationIssues = issues;
            throw validationError;
        }
    }
    handleValidationError(error) {
        const issues = [];
        error.details.forEach((issue) => {
            switch (issue.type) {
                case 'any.required': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRate', errors_1.Errors.ValidationErrorCode.requiredValue, issue.context?.key, undefined));
                    break;
                }
                case 'any.unknown':
                case 'object.unknown': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRate', errors_1.Errors.ValidationErrorCode.notAllowed, issue.context?.key, issue.context?.value));
                    break;
                }
                case 'object.base': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRate', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.key, issue.context?.value));
                    break;
                }
                case 'boolean.base':
                case 'string.base':
                case 'number.base': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRate', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.key, issue.context?.value));
                    break;
                }
                case 'number.min':
                case 'number.integer':
                case 'string.max':
                case 'string.min':
                case 'string.trim':
                case 'string.only':
                case 'string.empty':
                case 'string.pattern.base':
                case 'any.only': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRate', errors_1.Errors.ValidationErrorCode.invalidValue, issue.context?.key, issue.context?.value));
                    break;
                }
            }
        });
        return issues;
    }
}
exports.default = PerTransactionRateValidator;
